import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import PageLoading from "@/components/pageLoading";
import { HoxRoot } from "hox";
import { IntlProvider } from "react-intl";
import zhCN from "@/locales/zh-cn";
import enUS from "@/locales/en-us";
import zhTW from "@/locales/zh-tw";
import koKR from "@/locales/ko-kr";
import ruRU from "@/locales/ru-ru";
import jaJP from "@/locales/ja-jp";
import idID from "@/locales/id-id";
import viVN from "@/locales/vi-vn";
import "external-svg-loader";
import cookie from "@/utils/cookie";
import { getLangFromPath } from "@/utils/langPath";
import { applySeoMeta } from "@/utils/seo";

// 在项目最开始的地方引入下面的代码
// import Tingyun from "@tingyun-sdk/web";

// crowdin config
import otaClient from "@crowdin/ota-client";

if (
  process.env.NODE_ENV === "production" &&
  window.location.hostname.indexOf("voox.com") > -1
) {
  import("@tingyun-sdk/web").then((Tingyun) => {
    Tingyun.default.init({
      domain: "wkbrs2.tingyun.com",
      token: "dca7c23a60b34613a43c89dee7a18b0c",
      key: "RjBlqK18CZw",
      id: "c9GimOvzq44",
      page: {
        fpThreshold: 3000,
      },
      operation: {
        rageClickEnabled: false,
      },
      requestTracing: {
        propagators: ["tingyun"],
      },
      replay: {
        sampleRate: 0.1,
      },
    });
  });
}
const hash_master = "2347fcb0cc60110b6fdb6da05gb";
const hash_test = "1df338b258e0dfcfc5b03aa05gb";
const hash_dev = "a300e2c2f569e3e5e6272da05gb";
const crowdin_langs = {
  zh_TW: "zh-TW",
  zh_CN: "zh-CN",
  en_US: "en",
  ja_JP: "ja",
  ru_RU: "ru",
  vi_VN: "vi",
  id_ID: "id",
};

const langmap = {
  EN_US: enUS,
  ZH_CN: zhCN,
  ZH_TW: zhTW,
  KO_KR: koKR,
  RU_RU: ruRU,
  JA_JP: jaJP,
  ID_ID: idID,
  VI_VN: viVN,
};
function browserLang() {
  var ls = navigator.languages ? navigator.languages.length : 0;
  var res = ls
    ? navigator.languages[0]
    : navigator.language || navigator.userLanguage;
  // es, es-us, es-mx,es-gt等等西班牙语，统一使用 es
  if (/^es-?/.test(res)) {
    res = "es-es";
  }
  return res.replace("-", "_");
}
const lang = getLangFromPath();
const result = langmap[lang.toUpperCase()] || enUS;
applySeoMeta();

function addZdassets(url) {
  if (window.voox_co) {
    return;
  }
  if (document.querySelector("#ze-snippet") || !url) return;
  var script = document.createElement("script");
  script.id = "ze-snippet";
  script.async = true;
  script.src = url;
  script.onload = function () {
    // var lang = window.localStorage.lang;
    var langObj = {
      en_US: "en-US",
      zh_CN: "zh-cn",
      zh_TW: "zh-tw",
      ja_JP: "ja",
      vi_VN: "vi",
      es_es: "es",
      th_TH: "th",
      ru_RU: "ru",
      de_DE: "de",
      fr_FR: "fr",
      tr_TR: "tr",
      id_ID: "id",
    };
    window.zE(function () {
      // zE("messenger:set", "locale", langObj[lang]);
      window.zE("messenger:set", "locale", langObj[lang]);
      window.zE("messenger", "hide");
      window.zE("messenger", "close");
      window.zE("messenger:on", "close", () => {
        window.zE("messenger", "hide");
      });
      window.zE("messenger:on", "open", () => {
        window.zE("messenger", "show");
      });
    });
  };
  document.querySelector("body").appendChild(script);
}
// 延迟加载Zendesk，不阻塞页面渲染
if (typeof window !== "undefined") {
  if ("requestIdleCallback" in window) {
    requestIdleCallback(
      function () {
        addZdassets &&
          addZdassets(
            "https://static.zdassets.com/ekr/snippet.js?key=a28bae0e-3033-4476-952f-41ac37806a90",
          );
      },
      { timeout: 3000 },
    );
  } else {
    // 降级方案：延迟3秒加载
    setTimeout(function () {
      addZdassets &&
        addZdassets(
          "https://static.zdassets.com/ekr/snippet.js?key=a28bae0e-3033-4476-952f-41ac37806a90",
        );
    }, 3000);
  }
}

let hash = hash_master;
const nowHost = window.location.host;
if (nowHost.indexOf("kooex.cc") > -1) {
  hash = hash_dev;
}
if (nowHost.indexOf("kooex.info") > -1 || nowHost.indexOf("localhost") > -1) {
  hash = hash_test;
}
const client = new otaClient(hash);
let crowdinLan = crowdin_langs[lang] || "en";

const init = async () => {
  try {
    const langs = await client.listLanguages();
    if (langs.length > 0) {
      const index = langs.findIndex((item) => item == crowdinLan);
      if (index == -1) {
        crowdinLan = "en";
      }
    }
    const res = await client.getStringsByLocale(crowdinLan);
    if (res) {
      // json格式扁平化
      let flat = {};
      const flatObj = (obj, path = "") => {
        for (let key in obj) {
          if (typeof obj[key] === "object") {
            flatObj(obj[key], path + key + ".");
          } else {
            flat[path + key] = obj[key];
          }
        }
      };
      flatObj(res);
      console.log("crowdin flat", flat);
      result.messages = flat;
    }
  } catch (error) {
    console.log("crowdin error", error);
  }
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <IntlProvider
      locale={result.locale}
      messages={result.messages}
      formats={result.formats}
      onError={(info) => {}}
    >
      <HoxRoot>
        <RouterProvider router={router} fallbackElement={<PageLoading />} />
      </HoxRoot>
    </IntlProvider>,
  );
};
init();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
